// extracted by mini-css-extract-plugin
module.exports = {"contentIcon":"ContentIcon_contentIcon__ktKVI"};